import { IsIn, IsOptional, ValidateNested } from 'class-validator';

import { CrudShowMode } from './crud-show-mode';
import { CrudPaginateRequest } from './crud-paginate.request';

export class CrudItemListRequest {
    @IsOptional()
    @IsIn([CrudShowMode.all, CrudShowMode.deleted, CrudShowMode.undeleted])
    public show?: CrudShowMode;

    @ValidateNested()
    public paginateInfo?: CrudPaginateRequest;

    constructor(data?: Partial<CrudItemListRequest>) {
        this.show = data?.show;
        this.paginateInfo = data?.paginateInfo && new CrudPaginateRequest(data.paginateInfo);
    }
}
